export const PREVIEW_MIN_HEIGHT = 320;
export const VIEWPORT_VERTICAL_OFFSET = 160;
export const TABLET_BREAKPOINT = 768;
export const MOBILE_BREAKPOINT = 540;

export const VIEW_PRESETS = {
    desktop: { width: 1400, height: 900 },
    tablet: { width: 768, height: 1024 },
    mobile: { width: 402, height: 874 }
};

export const viewOptions = [
    { id: 'desktop', label: 'Desktop' },
    { id: 'tablet', label: 'Tablet' },
    { id: 'mobile', label: 'Mobile' }
]

export const DEFAULT_DEVICE_ASPECT_RATIO = '9:21';

const parseAspectRatio = (aspectRatio = DEFAULT_DEVICE_ASPECT_RATIO) => {
    const [widthPart, heightPart] = String(aspectRatio).split(':').map((value) => Number(value));
    const safeWidth = Number.isFinite(widthPart) && widthPart > 0 ? widthPart : 9;
    const safeHeight = Number.isFinite(heightPart) && heightPart > 0 ? heightPart : 21;
    return { widthRatio: safeWidth, heightRatio: safeHeight };
};

const normalizePresetByAspectRatio = (preset) => {
    const ratio = preset.aspectRatio || DEFAULT_DEVICE_ASPECT_RATIO;
    const { widthRatio, heightRatio } = parseAspectRatio(ratio);
        const fontScale = Number.isFinite(preset.fontScale) && preset.fontScale > 0 ? preset.fontScale : 1;

    const width = Number.isFinite(preset.width) ? preset.width : null;
    const height = Number.isFinite(preset.height) ? preset.height : null;

    if (width !== null) {
        return {
            ...preset,
            aspectRatio: ratio,
                fontScale,
            width,
            height: Math.round((width / widthRatio) * heightRatio)
        };
    }

    if (height !== null) {
        return {
            ...preset,
            aspectRatio: ratio,
                fontScale,
            width: Math.round((height / heightRatio) * widthRatio),
            height
        };
    }

    return {
        ...preset,
        aspectRatio: ratio,
           fontScale,
    };
};

export const DEVICE_PRESETS = [
    { id: 'iphone-16e', label: 'iPhone 16e', width: 390, aspectRatio: '195:422', fontScale: 1 },
    { id: 'iphone-17-pro', label: 'iPhone 17 Pro', width: 402, aspectRatio: '201:437', fontScale: 0.84 },
    { id: 'iphone-17-pro-max', label: 'iPhone 17 Pro Max', width: 440, aspectRatio: '201:437', fontScale: 1.015 },
    { id: 'iphone-air', label: 'iPhone Air', width: 420, aspectRatio: '105:228', fontScale: 1.07 },
    { id: 'ipad-mini', label: 'iPad Mini', width: 744, aspectRatio: '2:3', fontScale: 1 },
    { id: 'ipad', label: 'iPad', width: 820, aspectRatio: '2:3', fontScale: 1 },
    { id: 'ipad-pro-11', label: 'iPad Pro 11"', width: 834, aspectRatio: '2:3', fontScale: 1 },
    { id: 'ipad-pro-12', label: 'iPad Pro 13"', width: 1032, aspectRatio: '3:4', fontScale: 1 }
].map(normalizePresetByAspectRatio);

export const DEVICE_SAFE_AREAS = {
    'iphone-16e': { top: 47, right: 0, bottomOpen: 96, bottomClosed: 54, left: 0 },
    'iphone-17-pro': { top: 59, right: 0, bottomOpen: 96, bottomClosed: 64, left: 0 },
    'iphone-17-pro-max': { top: 59, right: 0, bottomOpen: 102, bottomClosed: 64, left: 0 },
    'iphone-air': { top: 62, right: 0, bottomOpen: 98, bottomClosed: 64, left: 0 }
};

export const DEVICE_SIMULATOR_CONFIG = {
    'iphone-16e': {
        hasDynamicIsland: false,
        hasNotch: true,
        statusBarTop: 12,
        statusBarSide: 30,
        timeFontSize: 16,
        statusIconsScale: 0.85,
        islandTop: 0,
        islandWidth: 172,
        islandHeight: 34,
    },
    'iphone-17-pro': {
        hasDynamicIsland: true,
        statusBarTop: 16,
        statusBarSide: 44,
        timeFontSize: 16,
        statusIconsScale: 1,
        islandTop: 12,
        islandWidth: 132,
        islandHeight: 38,
    },
    'iphone-17-pro-max': {
        hasDynamicIsland: true,
        statusBarTop: 16,
        statusBarSide: 52,
        timeFontSize: 18,
        statusIconsScale: 1,
        islandTop: 12,
        islandWidth: 132,
        islandHeight: 38,
    },
    'iphone-air': {
        hasDynamicIsland: true,
        statusBarTop: 18,
        statusBarSide: 44,
        timeFontSize: 18,
        statusIconsScale: 1,
        islandTop: 12,
        islandWidth: 138,
        islandHeight: 38,
    }
};

export const imageLoadingOptions = [
    {
        id: 0,
        name: 'Eager',
        value: 'eager'
    },
    {
        id: 1,
        name: 'Lazy',
        value: 'lazy'
    }
]

export const fetchPriorityOptions = [
    {
        id: 0,
        name: 'Automatica',
        value: 'auto'
    },
    {
        id: 1,
        name: 'Alta',
        value: 'high'
    },
    {
        id: 2,
        name: 'Bassa',
        value: 'low'
    }
]

export const borderOptions = [
    {
        id: 0,
        name: 'Nessuno',
        value: 'none'
    },
    {
        id: 1,
        name: 'Solido',
        value: 'solid'
    },
    {
        id: 2,
        name: 'Punteggiato',
        value: 'dotted'
    },
    {
        id: 3,
        name: 'Tratteggiato',
        value: 'dashed'
    }
]

export const backgroundSizeOptions = [
    {
        id: 0,
        name: 'Non Set',
        value: ''
    },
    {
        id: 1,
        name: 'Fit',
        value: 'contain'
    },
    {
        id: 2,
        name: 'Fill',
        value: 'cover'
    }
]

export const backgroundPositionOptions = [
    {
        id: 0,
        name: 'Not Set',
        value: ''
    },
    {
        id: 1,
        name: 'Top',
        value: 'top'
    },
    {
        id: 2,
        name: 'Center',
        value: 'center'
    },
    {
        id: 3,
        name: 'Bottom',
        value: 'bottom'
    },
    {
        id: 4,
        name: 'Left',
        value: 'left'
    },
    {
        id: 5,
        name: 'Right',
        value: 'right'
    },
    {
        id: 6,
        name: 'Top Left',
        value: 'top left'
    },
    {
        id: 7,
        name: 'Top Right',
        value: 'top right'
    },
    {
        id: 8,
        name: 'Bottom Left',
        value: 'bottom left'
    },
    {
        id: 9,
        name: 'Bottom Right',
        value: 'bottom right'
    },
    {
        id: 10,
        name: 'Center Left',
        value: 'center left'
    },
    {
        id: 11,
        name: 'Center Right',
        value: 'center right'
    },
    {
        id: 12,
        name: 'Center Top',
        value: 'center top'
    },
    {
        id: 13,
        name: 'Center Bottom',
        value: 'center bottom'
    }
]

export const backgroundRepeatOptions = [
    {
        id: 0,
        name: 'No Repeat',
        value: 'no-repeat'
    },
    {
        id: 1,
        name: 'Repeat',
        value: 'repeat'
    }
]

export const fontWeightOptions = [
    {
        id: 0,
        name: 'Thin',
        value: '100'
    },
    {
        id: 1,
        name: 'Extra Light',
        value: '200'
    },
    {
        id: 2,
        name: 'Light',
        value: '300'
    },
    {
        id: 3,
        name: 'Regular',
        value: '400'
    },
    {
        id: 4,
        name: 'Medium',
        value: '500'
    },
    {
        id: 5,
        name: 'Semi Bold',
        value: '600'
    },
    {
        id: 6,
        name: 'Bold',
        value: '700'
    },
    {
        id: 7,
        name: 'Extra Bold',
        value: '800'
    },
    {
        id: 8,
        name: 'Heavy',
        value: '900'
    }
]

export const overflowOptions = [
    {
        id: 0,
        name: 'Visible',
        value: 'visible'
    },
    {
        id: 1,
        name: 'Hidden',
        value: 'hidden'
    },
    {
        id: 2,
        name: 'Scroll',
        value: 'scroll'
    },
    {
        id: 3,
        name: 'Auto',
        value: 'auto'
    }
]

export const buttonAppearanceOptions = [
    {
        id: 0,
        name: 'Default',
        value: 'default'
    },
    {
        id: 1,
        name: 'Embedded',
        value: 'text'
    },
    {
        id: 2,
        name: 'Outlined',
        value: 'outlined'
    }
]

export const iconPositionOptions = [
    {
        id: 0,
        name: 'Left',
        value: 'left'
    },
    {
        id: 1,
        name: 'Right',
        value: 'right'
    },
    { 
        id: 2,
        name: 'Top',
        value: 'top'
    },
    {
        id: 3,
        name: 'Bottom',
        value: 'bottom'
    }
]

export const rowWrapOptions = [
    {
        id: 0,
        name: 'No Wrap',
        value: 'nowrap'
    },
    {
        id: 1,
        name: 'Wrap',
        value: 'wrap'
    },
    {
        id: 2,
        name: 'Wrap Reverse',
        value: 'wrap-reverse'
    }
]

export const flexDirectionOptions = [
    {
        id: 0,
        name: 'Row',
        value: 'row'
    },
    {
        id: 1,
        name: 'Row Reverse',
        value: 'row-reverse'
    },
    {
        id: 2,
        name: 'Column',
        value: 'column'
    },
    {
        id: 3,
        name: 'Column Reverse',
        value: 'column-reverse'
    }
]

export const positionOptions = [
    {
        id: 0,
        name: 'Relative',
        value: 'relative'
    },
    {
        id: 1,
        name: 'Absolute',
        value: 'absolute'
    },
    {
        id: 2,
        name: 'Fixed',
        value: 'fixed'
    },
    {
        id: 3,
        name: 'Sticky',
        value: 'sticky'
    }
]

export const buttonTypeOptions = !window.location.pathname.includes('/events/') ? [
    {
        id: 0,
        name: 'Naviga',
        value: 'navigate_to'
    },
    {
        id: 1,
        name: 'Indietro',
        value: 'navigate_back'
    },
    {
        id: 2,
        name: 'Acquisto',
        value: 'purchase'
    },
    {
        id: 3,
        name: 'Candidatura',
        value: 'apply'
    },
    {
        id: 5,
        name: 'Scarica brochure',
        value: 'brochure'
    },
    {
        id: 4,
        name: 'Biglietto',
        value: 'ticket'
    }
] :

    [{
        id: 0,
        name: 'Naviga',
        value: 'navigate_to'
    },
    {
        id: 1,
        name: 'Indietro',
        value: 'navigate_back'
    },
    {
        id: 2,
        name: 'Biglietto',
        value: 'ticket'
    }
    ]


export const carouselTypeOptions = [
    {
        id: 0,
        name: 'Slide',
        value: 'slide'
    },
    {
        id: 1,
        name: 'Loop',
        value: 'loop'
    },
    {
        id: 2,
        name: 'Fade',
        value: 'fade'
    }
]

export const fieldTypeOptions = [
    {
        id: 0,
        name: 'Testo',
        value: 'text'
    },
    {
        id: 1,
        name: 'Area di testo',
        value: 'textarea'
    },
    {
        id: 2,
        name: 'Checkbox',
        value: 'checkbox'
    }
]

export const fontOptions = [
    { id: 1, name: 'Montserrat', value: 'Montserrat, sans-serif' },
    { id: 2, name: 'Inter', value: 'Inter, sans-serif' },
    { id: 3, name: 'Sora', value: 'Sora, sans-serif' },
]

export const themeColors = [
    {
        id: 0,
        name: 'Primary',
        value: 'rgba(76, 180, 255, 1)',
        hex: '#16B4FA'
    },
    {
        id: 1,
        name: 'Secondary',
        value: 'rgba(109, 74, 255, 1)',
        hex: '#6d4aff'
    },
    {
        id: 3,
        name: 'Red',
        value: 'rgba(250, 102, 117, 1)',
        hex: '#fa6675'

    },
    {
        id: 4,
        name: 'Green',
        value: 'rgba(47, 198, 160, 1)',
        hex: '#2fc6a0'

    },
    {
        id: 5,
        name: 'Yellow',
        value: 'rgba(247, 164, 0, 1)',
        hex: '#F7A400'

    },
    {
        id: 6,
        name: 'Black',
        value: 'rgba(38, 38, 38, 1)',
        hex: '#2A2A2A'

    },
    {
        id: 7,
        name: 'Background',
        value: 'rgba(252, 252, 252, 1)',
        hex: '#fcfcfc'

    },
    {
        id: 8,
        name: 'Background 2',
        value: 'rgba(244, 244, 244, 1)',
        hex: '#f4f4f4'

    },
    {
        id: 9,
        name: 'Gray',
        value: 'rgba(181, 184, 190, 1)',
        hex: '#B5B8BE'

    }
]


export const actionsOptions = [
    {
        id: 0,
        name: 'On Click',
        value: 'onClick'
    },
    {
        id: 1,
        name: 'On Hover',
        value: 'onHover'
    }
]

export const cssProperties = [
    {
        id: 0,
        name: 'Width',
        value: 'width'
    },
    {
        id: 1,
        name: 'Height',
        value: 'height'
    },
    {
        id: 2,
        name: 'Min Width',
        value: 'min-width'
    },
    {
        id: 3,
        name: 'Min Height',
        value: 'min-height'
    },
    {
        id: 4,
        name: 'Max Width',
        value: 'max-width'
    },
    {
        id: 5,
        name: 'Max Height',
        value: 'max-height'
    },
    {
        id: 6,
        name: 'Display',
        value: 'display'
    },
    {
        id: 7,
        name: 'Gap',
        value: 'gap'
    },
    {
        id: 8,
        name: 'Justify Content',
        value: 'justify-content'
    },
    {
        id: 9,
        name: 'Align Items',
        value: 'align-items'
    },
    {
        id: 10,
        name: 'Overflow',
        value: 'overflow'
    },
    {
        id: 11,
        name: 'Flex Wrap',
        value: 'flex-wrap'
    },
    {
        id: 12,
        name: 'Flex Direction',
        value: 'flex-direction'
    },
    {
        id: 13,
        name: 'Z-Index',
        value: 'z-index'
    },
    {
        id: 14,
        name: 'Position',
        value: 'position'
    },
    {
        id: 15,
        name: 'Top',
        value: 'top'
    },
    {
        id: 16,
        name: 'Right',
        value: 'right'
    },
    {
        id: 17,
        name: 'Bottom',
        value: 'bottom'
    },
    {
        id: 18,
        name: 'Left',
        value: 'left'
    },
    {
        id: 19,
        name: 'Opacity',
        value: 'opacity'
    },
    {
        id: 20,
        name: 'Font Family',
        value: 'font-family'
    },
    {
        id: 21,
        name: 'Font Size',
        value: 'font-size'
    },
    {
        id: 22,
        name: 'Font Weight',
        value: 'font-weight'
    },
    {
        id: 23,
        name: 'Text Align',
        value: 'text-align'
    },
    {
        id: 24,
        name: 'Line Height',
        value: 'line-height'
    },
    {
        id: 25,
        name: 'Transform',
        value: 'transform'
    },
    {
        id: 26,
        name: 'Box Shadow',
        value: 'box-shadow'
    },
    {
        id: 27,
        name: 'Background Color',
        value: 'background-color'
    },
    {
        id: 28,
        name: 'Background Image',
        value: 'background-image'
    },
    {
        id: 29,
        name: 'Text Transform',
        value: 'text-transform'
    },
    {
        id: 30,
        name: 'Text Decoration',
        value: 'text-decoration'
    },
    {
        id: 31,
        name: 'Object Fit',
        value: 'object-fit'
    },
    {
        id: 32,
        name: 'Color',
        value: 'color'
    },
    {
        id: 33,
        name: 'Padding',
        value: 'padding'
    },
    {
        id: 34,
        name: 'Margin',
        value: 'margin'
    },
    {
        id: 35,
        name: 'Border',
        value: 'border'
    },
    {
        id: 36,
        name: 'Border Radius',
        value: 'border-radius'
    },
    {
        id: 37,
        name: 'Visibility',
        value: 'visibility'
    },
    {
        id: 38,
        name: 'Cursor',
        value: 'cursor'
    }
]

export const visibilityOptions = [
    {
        id: 0,
        name: 'Visible',
        value: 'visible'
    },
    {
        id: 1,
        name: 'Hidden',
        value: 'hidden'
    }
]

export const whiteSpaceOptions = [
    {
        id: 0,
        name: 'Normal',
        value: 'normal'
    },
    {
        id: 1,
        name: 'No Wrap',
        value: 'nowrap'
    },
    {
        id: 2,
        name: 'Pre',
        value: 'pre'
    },
    {
        id: 3,
        name: 'Pre Wrap',
        value: 'pre-wrap'
    },
    {
        id: 4,
        name: 'Pre Line',
        value: 'pre-line'
    },
    {
        id: 5,
        name: 'Break Spaces',
        value: 'break-spaces'
    },
    {
        id: 6,
        name: 'Inherit',
        value: 'inherit'
    }
]

export const cursorOptions = [
    {
        id: 0,
        name: 'Default',
        value: 'default'
    },
    {
        id: 1,
        name: 'Pointer',
        value: 'pointer'
    },
    {
        id: 2,
        name: 'Move',
        value: 'move'
    },
    {
        id: 3,
        name: 'Text',
        value: 'text'
    },
    {
        id: 4,
        name: 'Not Allowed',
        value: 'not-allowed'
    },
    {
        id: 5,
        name: 'Grab',
        value: 'grab'
    },
    {
        id: 6,
        name: 'Grabbing',
        value: 'grabbing'
    },
    {
        id: 7,
        name: 'Crosshair',
        value: 'crosshair'
    },
    {
        id: 8,
        name: 'Help',
        value: 'help'
    },
    {
        id: 9,
        name: 'Wait',
        value: 'wait'
    },
    {

    }
]